import styled from "styled-components";

export const Box = styled.div`
  .interDisplay {
    font-family: InterDisplay;
  }
  .defaultText {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
      Ubuntu, Cantarell, sans-serif;
  }
  .crc-container {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
      Ubuntu, Cantarell, sans-serif;
  }
      ::-webkit-scrollbar {
  display: none;
}
* {
  -ms-overflow-style: none;
  scrollbar-width: none;
}


  .crc-header {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 0.75rem;
  }

  .crc-calculator-icon {
    color: #2563eb;
  }

  .crc-icon-wrapper {
    width: 60px;
    height: 60px;
    border-radius: 12px;
    background: linear-gradient(135deg, #dbeafe, #bfdbfe);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .crc-card {
    background-color: white;
    border-radius: 16px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
    padding: 1.5rem;
    margin-bottom: 2rem;
  }

  .crc-form-grid {
    display: grid;
    grid-template-columns: 1fr;
    gap: 1.5rem;
    margin-bottom: 1.5rem;
  }

  .crc-form-group {
    margin-bottom: 1.5rem;
  }

  .crc-form-group label {
    display: block;
    font-size: 0.875rem;
    font-weight: 500;
    color: #374151;
    margin-bottom: 0.5rem;
  }

  .crc-custom-input,
  .crc-custom-select {
    height: 50px;
    border-radius: 10px;
    border: 1px solid #e5e7eb;
    padding: 0.75rem 1rem;
    font-size: 1rem;
    color: #1f2937;
    background-color: white;
    transition: border-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
  }

  .crc-custom-input:focus,
  .crc-custom-select:focus {
    border-color: #2563eb;
    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
    outline: none;
  }

  .crc-custom-input::placeholder {
    color: #6b7280;
  }

  .crc-custom-select {
    appearance: none;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='%23374151' viewBox='0 0 16 16'%3E%3Cpath d='M8 12l-4-4h8l-4 4z'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 1rem center;
    background-size: 12px;
  }

  .crc-button-container {
    display: flex;
    justify-content: center;
  }

  .crc-custom-button {
    height: 50px;
    border-radius: 10px;
    font-size: 1rem;
    font-weight: 500;
    transition: background-color 0.2s ease-in-out, transform 0.1s ease-in-out;
  }

  .crc-custom-button:not(.crc-secondary-button) {
    background-color: #8CC540;
    border: none;
    color: white;

  }

  .crc-custom-button:not(.crc-secondary-button):hover {
    background-color: #8CC540;
    transform: translateY(-2px);
  }

  .crc-secondary-button {
    border: 1px solid #d1d5db;
    color: #374151;
    background-color: #ffffff;
  }

  .crc-secondary-button:hover {
    background-color: #f9fafb;
    transform: translateY(-2px);
  }

  .crc-error-message {
    background-color: rgba(220, 38, 38, 0.1);
    border-left: 3px solid #ef4444;
    padding: 0.75rem;
    font-size: 0.875rem;
  }

  .crc-help-text {
    font-size: 0.875rem;
    color: #6b7280;
  }

  .crc-result-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: 1.5rem;
  }

  .crc-rate {
    font-size: 2.25rem;
    font-weight: bold;
    margin-top: 0.5rem;
  }

  .crc-status-message {
    font-size: 1.125rem;
    font-weight: 500;
    margin-top: 0.5rem;
    padding: 0.5rem 1rem;
    border-radius: 0.375rem;
  }

  .crc-status-excellent {
    background-color: #dcfce7;
    color: #166534;
  }

  .crc-status-moderate {
    background-color: #fef9c3;
    color: #854d0e;
  }

  .crc-status-poor {
    background-color: #fee2e2;
    color: #991b1b;
  }

  .crc-status-icon {
    padding: 0.75rem;
    border-radius: 9999px;
  }

  .crc-benchmark-section {
    margin-bottom: 1.5rem;
  }

  .crc-benchmark {
    color: #4b5563;
    margin-bottom: 0.5rem;
    font-size: 18.75px;
    font-weight: bold;
  }

  .crc-benchmark span {
    font-size: 2.25rem;
    font-weight: bold;
    margin-top: 0.5rem;
    display: block;
  }

  .crc-progress-bar {
    width: 100%;
    height: 0.625rem;
    background-color: #e5e7eb;
    border-radius: 9999px;
    overflow: hidden;
  }

  .crc-progress {
    height: 100%;
    border-radius: 9999px;
    transition: width 0.3s ease;
  }

  .crc-progress-excellent {
    background-color: #22c55e;
  }

  .crc-progress-moderate {
    background-color: #eab308;
  }

  .crc-progress-poor {
    background-color: #ef4444;
  }

  .crc-recommendations-section {
    background-color: #f9fafb;
    padding: 1.5rem;
    border-radius: 12px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  }

  .crc-recommendations-list {
    list-style: none;
  }

  .crc-recommendations-list li {
    display: flex;
    align-items: flex-start;
    margin-bottom: 0.5rem;
  }

  .crc-recommendations-list li::before {
    content: "•";
    color: #22c55e;
    margin-right: 0.5rem;
  }

  .crc-bg-light {
    background-color: #f8fafc;
  }

  .crc-fs-2 {
    font-size: 2rem;
  }

  .crc-fs-4 {
    font-size: 1.5rem;
  }

  .crc-fs-5 {
    font-size: 1.125rem;
    font-weight: 600;
  }

  /* Mobile-specific styles */
  @media (max-width: 768px) {
    .crc-container {
      padding: 0.5rem; /* Reduced padding for mobile */
    }
      .gap-3 {
    gap: 0rem !important;
}

    .crc-card {
      padding: 1rem; /* Reduced card padding */
      margin-bottom: 1rem;
    }

    .crc-form-grid {
      gap: 1rem; /* Reduced gap between form elements */
      margin-bottom: 1rem;
    }

    .crc-form-group {
      margin-bottom: 1rem; /* Reduced margin for form groups */
    }

    .crc-form-group label {
      font-size: 0.75rem; /* Smaller labels */
    }

    .crc-custom-input,
    .crc-custom-select {
      height: 40px; /* Smaller input height */
      font-size: 0.875rem; /* Smaller font size */
      padding: 0.5rem 0.75rem;
    }

    .crc-custom-select {
      background-size: 10px; /* Smaller dropdown arrow */
    }

    .crc-button-container {
      justify-content: center; /* Center buttons */
      flex-direction: column;
    }

    .crc-custom-button {
      height: 40px; /* Smaller button height */
      font-size: 0.875rem; /* Smaller button text (overridden for primary button) */
    }

    .crc-btn-primary {
      font-size: 10px; /* Specific font size for Calculate Conversion Rate button */
    }

    .crc-button-group {
      flex-direction: column; /* Stack buttons vertically */
      gap: 0.5rem; /* Reduced gap between buttons */
    }

    .crc-error-message {
      font-size: 0.75rem; /* Smaller error text */
      padding: 0.5rem;
    }

    .crc-results-grid {
      grid-template-columns: 1fr; /* Stack result cards vertically */
      gap: 1rem; /* Reduced gap */
    }

    .crc-result-card {
      padding: 0.75rem; /* Reduced card padding */
    }

    .crc-rate {
      font-size: 1.5rem; /* Smaller rate text */
    }

    .crc-status-message {
      font-size: 0.875rem; /* Smaller status text */
      padding: 0.5rem;
    }

    .crc-benchmark {
      font-size: 1rem; /* Smaller benchmark text */
    }

    .crc-benchmark span {
      font-size: 1.5rem; /* Smaller benchmark value */
    }

    .crc-progress-bar {
      height: 0.5rem; /* Thinner progress bar */
    }

    .crc-recommendations-section {
      padding: 1rem; /* Reduced padding */
    }

    .crc-recommendations-list li {
      font-size: 0.875rem; /* Smaller recommendation text */
    }

    .crc-fs-2 {
      font-size: 1.5rem;
    }

    .crc-fs-4 {
      font-size: 1.25rem;
    }

    .crc-fs-5 {
      font-size: 1rem;
    }
      .crc-custom-button:not(.crc-secondary-button) {
    font-size: 11px; 
  }
  }
`;